<script setup lang="ts">
defineProps<{
  title: string
  subtitle?: string
}>()
</script>

<template>
  <div class="bg-white pt-16 md:pt-4 pb-8 px-4 w-full">
    <div class="text-[26px] font-bold mb-6 text-black">{{ title }}</div>
    <div v-if="subtitle" class="text-[15px] text-gray-800 font-medium mb-4">{{ subtitle }}</div>
    <div class="space-y-3">
      <slot></slot>
    </div>
  </div>
</template>
